import * as types from "../constants";
import { toggleTheme } from "../../Services/ThemeService";

export function enableDarkTheme() {
    return enableTheme("addons-Dark");
}
export function enableLightTheme() {
    return enableTheme("addons-Light");
}

function enableTheme(name: any) {
    toggleTheme(name);
    return {
        type: types.THEME_TOGGLE,
        payload: name
    };
}

export function MenuToggleCollapse() {
    return {
        type: types.MENU_TOGGLE_COLLAPSE
    };
}
export function MenuSetCollapse(collapsed: boolean) {
    return {
        type: types.MENU_SET_COLLAPSE,
        payload: collapsed

    };
}